import { createFileRoute } from '@tanstack/react-router';
import { AuthCallback } from '@onesource/components';

export const Route = createFileRoute('/auth/callback')({
  component: () => <AuthCallback redirectTo="/" errorRedirectTo="/auth/login" />,
});
